import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from '@mui/material/Dialog';
import utils from 'helpers/utils';

const StyledDialog = styled(Dialog)
  .attrs((props) => {
    let attr = props;

    const size = (value) => {
      return utils.isNumber(value) ? props.theme.layout(value) : null;
    };

    const vars = {
      '--dialog-width': size(props.$width),
      '--dialog-max-width': size(props.$maxWidth),
      '--dialog-min-width': size(props.$minWidth),
      '--dialog-height': size(props.$height),
      '--dialog-max-height': size(props.$maxHeight),
      '--dialog-min-height': size(props.$minHeight),
      '--dialog-min-width-height': props.$minWidth > 0 ?
        `clamp(0px, ${size(props.$minWidth)}, 86vw)` : 'unset',
      '--dialog-min-height-height': props.$minHeight > 0 ?
        `clamp(0px, ${size(props.$minHeight)}, 86vh)` : 'unset'
    };

    return utils.styleProps(attr, vars);
  })`
  &.Dialog-hide {
    visibility: hidden;
  }
  
  &.Dialog {
    .MuiDialog-container, .MuiDialog-paper {
      outline: none;
    }

    .MuiDialog-paper {
      > .Wrapper {
        flex-grow: 1;
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .notistack-SnackbarContainer {
          position: absolute;
          margin-bottom: 0;
          margin-right: 0;
          margin-left: -${props => props.theme.layout('0.75sp')};
          margin-top: -${props => props.theme.layout('0.5sp')};
        }
      }
    }

    ${props => utils.isNumber(props.$width) ? css`
      .MuiDialog-paper {
        width: clamp(0px, ${props.$css.$var('--dialog-width', false)}, 86vw);
        min-width: clamp(0px, ${props.$css.$var('--dialog-width', false)}, 86vw);
        max-width: clamp(0px, ${props.$css.$var('--dialog-width', false)}, 86vw);
      }
    ` : css``}

    ${props => utils.isNumber(props.$maxWidth) ? css`
      .MuiDialog-paper {
        max-width: clamp(0px, ${props.$css.$var('--dialog-max-width', false)}, 86vw);
      }
    ` : css``}

    ${props => utils.isNumber(props.$minWidth) ? css`
      .MuiDialog-paper {
        height: ${props.$css.$var('--dialog-min-width-height', false)};
        min-width: clamp(0px, ${props.$css.$var('--dialog-min-width', false)}, 86vw);
      }
    ` : css``}

    ${props => utils.isNumber(props.$height) ? css`
      .MuiDialog-paper {
        height: clamp(0px, ${props.$css.$var('--dialog-height', false)}, 86vh);
        min-height: clamp(0px, ${props.$css.$var('--dialog-height', false)}, 86vh);
        max-height: clamp(0px, ${props.$css.$var('--dialog-height', false)}, 86vh);
      }
    ` : css``}

    ${props => utils.isNumber(props.$maxHeight) ? css`
      .MuiDialog-paper {
        max-height: clamp(0px, ${props.$css.$var('--dialog-max-height', false)}, 86vh);
      }
    ` : css``}

    ${props => utils.isNumber(props.$minHeight) ? css`
      .MuiDialog-paper {
        height: ${props.$css.$var('--dialog-min-height-height', false)};
        min-height: clamp(0px, ${props.$css.$var('--dialog-min-height', false)}, 86vh);
      }
    ` : css``}
  }


  &.Dialog-placement {
    &-top {
      .MuiDialog-container {
        align-items: flex-start;

        .MuiDialog-paper {
          margin-top: 8vh;
        }
      }
    }
    &-bottom {
      .MuiDialog-container {
        align-items: flex-end;

        .MuiDialog-paper {
          margin-bottom: 8vh;
        }
      }
    }
  }

  ${props => props.theme.breakpoints.down('sm')} {
    .MuiDialog-paper {
      > .Wrapper {
        .notistack-SnackbarContainer {
          margin-left: -${props => props.theme.layout('1sp')};
          margin-top: -${props => props.theme.layout('0.75sp')};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledDialog;
